var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.875,
    r: 19.5,
    stroke: "#36A41D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1356_18944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8455 24.2285L27.4513 22.8343V18.052L28.3616 17.7238C28.5705 17.6485 28.7099 17.4503 28.71 17.2281C28.7102 17.006 28.5711 16.8076 28.3623 16.732L20.0345 13.7161C19.9186 13.6741 19.7914 13.6741 19.6755 13.7161L11.3478 16.732C11.1397 16.8074 11.0008 17.0046 11 17.2258C10.9992 17.4471 11.1366 17.6454 11.3441 17.7222L14.4175 18.8607V22.3358C14.4175 22.4437 14.4505 22.5489 14.5122 22.6374C14.5462 22.686 14.8675 23.1249 15.6902 23.539C16.7296 24.0622 18.0928 24.3275 19.742 24.3275C21.3899 24.3275 22.76 24.0627 23.8142 23.5405C24.6451 23.129 24.9771 22.6948 25.0123 22.6466C25.0781 22.5564 25.1135 22.4476 25.1135 22.3359V18.8948L26.3968 18.4321V22.8343L25.0026 24.2285C24.9037 24.3274 24.8481 24.4615 24.8481 24.6014C24.8481 24.7412 24.9036 24.8754 25.0026 24.9742L26.3968 26.3684V27.5382C26.3968 27.8294 26.6329 28.0655 26.9241 28.0655C27.2153 28.0655 27.4514 27.8294 27.4514 27.5382V26.3684L28.8456 24.9742C29.0515 24.7684 29.0515 24.4344 28.8455 24.2285ZM19.855 14.7727L26.6311 17.2267L19.7445 19.7095L13.0603 17.2334L19.855 14.7727ZM24.0589 22.1257C22.2563 23.7477 16.8998 23.5617 15.4721 22.1309V19.2514L19.5588 20.7653C19.6236 20.7756 19.6849 20.8315 19.9208 20.7669L24.0589 19.275L24.0589 22.1257ZM26.924 25.4043L26.1211 24.6014L26.924 23.7984L27.727 24.6014L26.924 25.4043Z",
    fill: "#36A41D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1356_18944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(11 11.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrad);
export default __webpack_public_path__ + "static/media/grad.0c5edcb595cfee10755895550edaae9a.svg";
export { ForwardRef as ReactComponent };